import * as PIXI from 'pixi.js';
import { FrontendErrorCode } from './api';
import { shuffle } from './MyHelpers';
import { ResourceIdentifier } from './ResourceManager/ResourceIdentifier';
import { service } from './services';


interface ListItem {
    pixiApp: PIXI.Application<HTMLCanvasElement>;
    resid: ResourceIdentifier;
}

let registeredPixiApps: ListItem[] = [];

export function RegisterPixi(application: PIXI.Application<HTMLCanvasElement>, resid: ResourceIdentifier) {
    registeredPixiApps.push({
        pixiApp: application,
        resid: resid
    });
}

export function UnregisterPixi(application: PIXI.Application<HTMLCanvasElement>, resid: ResourceIdentifier) {
    let index = registeredPixiApps.findIndex(item => item.pixiApp == application)
    if (index == -1) {
        throw "Can't find the pixi application instance"
    }

    registeredPixiApps = registeredPixiApps.filter((pixi, i) => i != index);
}

export function SwitchPixiDebug() {
    console.log(`All pixi apps`, registeredPixiApps);
    const currentIndex = registeredPixiApps.findIndex(li => li.pixiApp == globalThis.__PIXI_APP__);
    console.log(`Current pixi debug app ${currentIndex}`, registeredPixiApps[currentIndex] ?? "not found");

    const nextIndex = (currentIndex + 1) % registeredPixiApps.length;
    console.log(`Next pixi debug app ${nextIndex}`, registeredPixiApps[nextIndex] ?? "not found");

    const app = registeredPixiApps[nextIndex].pixiApp
    globalThis.__PIXI_APP__ = app;
    globalThis.__PIXI_DEVTOOLS__ = {
        app: app
    };

}

export function CrashPixi() {
    const sortedPixiApps = shuffle([...registeredPixiApps]);
    console.log(`Have ${sortedPixiApps.length} pixi apps`, sortedPixiApps);

    for (let item of registeredPixiApps) {

        console.log("Crashing pixi app", item.resid.ID());

        // try webgl2 first
        let webgl2Context = item.pixiApp.view.getContext("webgl2", {});
        if (webgl2Context) {
            webgl2Context.getExtension('WEBGL_lose_context')?.loseContext();
            //continue;
        }

        // try webgl2 too
        let webglContext = item.pixiApp.view.getContext("webgl", {});
        if (webglContext != null) {
            webglContext.getExtension('WEBGL_lose_context')?.loseContext();
            //continue;
        }

        // nothing worked

    }
}

export function countSceneObjects(container: PIXI.Container) {
    let count = 1;
    for (const child of container.children) {
        if (child instanceof PIXI.Container) {
            count += countSceneObjects(child);
        } else {
            count++;
        }
    }

    return count;
}

interface Performance {
    memory: {
        jsHeapSizeLimit: number;
        totalJSHeapSize: number;
        usedJSHeapSize: number;
    }
}

export function PixiDebugStats(trigger: string) {
    let info: string[] = [];
    info.push(`Triggered by: ${trigger}`);

    const performance: Performance = window.performance as any as Performance;
    info.push(`JS Heap size limit: ${Math.round(performance?.memory?.jsHeapSizeLimit / 1024 / 1024)} MB`);
    info.push(`Total JS Heap size: ${Math.round(performance?.memory?.totalJSHeapSize / 1024 / 1024)} MB`);
    info.push(`Used JS Heap size: ${Math.round(performance?.memory?.usedJSHeapSize / 1024 / 1024)} MB`);

    const cachedTexturesCount = Object.keys(PIXI.utils.BaseTextureCache).length;
    info.push(`Base texture cache size: ${cachedTexturesCount}`);

    const textureCount = Object.keys(PIXI.utils.TextureCache).length;
    info.push(`Texture cache size: ${textureCount}`);

    for (const registeredItem of registeredPixiApps) {
        const app = registeredItem.pixiApp;
        const objects = countSceneObjects(app.stage);

        info.push(`App ${registeredItem.resid.ID()} objects: ${objects}`);
    }


    const strinfo = info.join("\r\n");
    console.log("Pixi debug info\r\n", strinfo);

    void service.api.frontendError(FrontendErrorCode.FrontendStats, strinfo);
}



export function DebugPixiTexutres() {
    console.log("Base texture list");
    console.log(PIXI.utils.TextureCache);
    (window as any).PIXI = PIXI;
    (window as any).TextureCache = PIXI.utils.TextureCache;
}

export function DebugPixiBaseTextures() {
    console.log("Base texture list");
    console.log(PIXI.utils.BaseTextureCache);
}

export function DebugPixiClearTextureCache() {

}

export function DebugPixiDuplicatedTextures() {

    let counts: { [key: string]: number } = Object.values(PIXI.utils.TextureCache)
        .map(t => (t as any).internalId as string)
        .reduce((acc, str) => { acc[str] = (acc[str] || 0) + 1; return acc; }, {});

    const sortedCounts = [...Object.entries(counts)].sort((a, b) => b[1] - a[1]);

    console.log("Duplicated textures");
    console.log(sortedCounts);
}
